import GpsContainerNav from './gps-container-nav'
import GpsManagementReport from './index';
import GpsDevices from '../gps-devices/index';

interface IProps {
    activeKey: string,
    subKey: string
}

const GpsContainer = (props: IProps) => {
    return (
        <>
            <GpsContainerNav activeKey={props.activeKey} />

            <div style={{ padding: 10 }}>
                {props.activeKey == 'GPS-TRACKING' &&
                    <GpsManagementReport centerId={0} activeKey={props.subKey} />
                }

                {props.activeKey == 'GPS-DEVICES' &&
                    <GpsDevices />
                }
            </div>
        </>
    );
}

export default GpsContainer;